<template>
  <div class="menu-main">
    <el-menu
      class="el-menu-vertical-demo"
      background-color="#f8fbff"
      text-color="#5f6f8f"
      active-text-color="#2f436d"
      :unique-opened="true"
      :default-active="activeMenuIndex"
      :default-openeds="openSubMenu"
      @select="handleMenuSelect"
    >
    <router-link to="/dashboard" class="router-link">
      <el-menu-item index="1" class="menu-logo-item">
        <i class="el-icon-s-home menu-logo-icon"></i>
        <span slot="title" class="onekids-title">ONEKIDS TEACHER</span>
      </el-menu-item>
    </router-link>
    <el-submenu index="9" class="menu-group-news">
        <template #title>
          <i class="el-icon-notebook-2"/>
          <span class="title_nav">
            Bảng tin
          </span>
        </template>
        <router-link to="/notifihis/notify-teacher" class="router-link">
          <el-menu-item
              index="2-10"
              @click="changeBreadcrumbMethod('notifihis-notify-teacher')"
          >Tin tức lớp học
          </el-menu-item>
        </router-link>
        <router-link to="/appsend/parent-feedback" class="router-link">
          <el-menu-item
              v-if="checkPermission(['news_feedbackParent'])"
              index="2-3"
              @click="changeBreadcrumbMethod('appsend-parent-feedback')"
          >
            <div class="wrap_title_nav">
              <span>Phụ huynh góp ý</span>
              <div v-if="parentFeedback > 0" class="notification_nav">{{ parentFeedback }}</div>
            </div>
          </el-menu-item
          >
        </router-link>
        <router-link to="/appsend/teacher-feedback" class="router-link">
          <el-menu-item
              index="2-4"
              v-if="checkPermission(['news_feedbackTeacher'])"
              @click="changeBreadcrumbMethod('appsend-teacher-feedback')"
          >
            <div class="wrap_title_nav">
              <span>Giáo viên góp ý</span>
              <div v-if="teacherFeedback > 0" class="notification_nav">{{ teacherFeedback }}</div>
            </div>
          </el-menu-item
          >
        </router-link>
        <router-link to="/survey_form/manager" class="router-link">
          <el-menu-item
              index="2-5"
              v-if="checkPermission(['news_survey'])"
              @click="changeBreadcrumbMethod('survey-form-manager')"
          >
            Phiếu khảo sát
          </el-menu-item>
        </router-link>
      </el-submenu>
    <el-submenu index="2" class="menu-group-diary">
      <template #title>
        <i class="el-icon-reading"/>
        <span>Nhật ký phụ huynh</span>
      </template>
      <router-link
          to="/parentdiary/message-parent"
          class="router-link"
      >
        <el-menu-item
            index="2-1"
            v-if="checkPermission(['parentDiary_message'])"
            @click="changeBreadcrumbMethod('parentdiary-message-parent')"
        >Lời nhắn
        </el-menu-item>
      </router-link>
      <router-link
          to="/parentdiary/medicine"
          class="router-link"
      >
        <el-menu-item
            index="2-2"
            v-if="checkPermission(['parentDiary_medicine'])"
            @click="changeBreadcrumbMethod('parentdiary-medicine')"
        >Dặn thuốc
        </el-menu-item>
      </router-link>
      <router-link
          to="/parentdiary/take-leave"
          class="router-link"
      >
        <el-menu-item
            index="2-3"
            v-if="checkPermission(['parentDiary_absenLetter'])"
            @click="changeBreadcrumbMethod('parentdiary-take-leave')"
        >Xin nghỉ
        </el-menu-item>
      </router-link>
      <router-link to="/absent_letter/daily" class="router-link">
        <el-menu-item
            index="2-6"
            v-if="checkPermission(['absent_letter_v4'])"
            @click="changeBreadcrumbMethod('absent-letter_v4')"
        >Xin nghỉ
        </el-menu-item>
      </router-link>
    </el-submenu>

    <el-submenu index="3" class="menu-group-student"
                v-if="checkPermission(['kids'])"
    >
      <template #title>
        <i class="el-icon-user-solid"/>
        <span>Quản lý học sinh</span>
      </template>
      <router-link to="/student/students" class="router-link">
        <el-menu-item
            index="3-1"
            v-if="checkPermission(['kids_list'])"
            @click="changeBreadcrumbMethod('student-students')"
        >Danh sách học sinh
        </el-menu-item>
      </router-link>
    </el-submenu>
    <el-submenu index="4" class="menu-group-quality"
                v-if="
          checkPermission(['studentQuality', 'attendance_v4', 'student-evaluation-v4'])
        "
    >
      <template #title>
        <i class="el-icon-document-checked"/>
        <span>Chất lượng học sinh</span>
      </template>
      <router-link to="/student-quality/attendance" class="router-link">
        <el-menu-item
            index="4-1"
            v-if="checkPermission(['studentQuality_attendance'])"
            @click="changeBreadcrumbMethod('student-quality-attendance')"
        >Điểm danh
        </el-menu-item>
      </router-link>
      <router-link to="/student-quality/attendance/v2" class="router-link">
        <el-menu-item
            v-if="checkPermission(['studentQuality_attendance_v2'])"
            index="4-2"
            @click="changeBreadcrumbMethod('student-quality-attendance_v2')"
        >Điểm danh
        </el-menu-item
        >
      </router-link>
      <router-link to="/attendance/daily" class="router-link">
        <el-menu-item
            v-if="checkPermission(['attendance_v4'])"
            index="4-8"
            @click="changeBreadcrumbMethod('attendance-v4')"
        >Điểm danh
        </el-menu-item>
      </router-link>
      <router-link to="/student-quality/evaluate" class="router-link">
        <el-menu-item
            index="4-3"
            v-if="checkPermission(['studentQuality_evaluate'])"
            @click="changeBreadcrumbMethod('student-quality-evaluate')"
        >Nhận xét
        </el-menu-item>
      </router-link>
      <router-link to="/evaluation-v4" class="router-link">
        <el-menu-item
            index="4-9"
            v-if="checkPermission(['student-evaluation-v4'])"
            @click="changeBreadcrumbMethod('student-evaluation-v4')"
        >Nhận xét
        </el-menu-item>
      </router-link>
      <router-link to="/album-v2" class="router-link">
        <el-menu-item
            index="4-4"
            v-if="checkPermission(['studentQuality_ablum'])"
            @click="changeBreadcrumbMethod('student-quality-album')"
        >Album ảnh
        </el-menu-item>
      </router-link>
      <router-link to="/student-quality/height-weight" class="router-link">
        <el-menu-item
            index="4-5"
            v-if="checkPermission(['studentQuality_heightWeight'])"
            @click="changeBreadcrumbMethod('student-quality-height-weight')"
        >Chiều cao, cân nặng
        </el-menu-item>
      </router-link>
      <router-link to="/student-quality/schedule" class="router-link">
        <el-menu-item
            index="4-6"
            v-if="checkPermission(['studentQuality_schedule'])"
            @click="changeBreadcrumbMethod('student-quality-schedule')"
        >Thời khóa biểu
        </el-menu-item>
      </router-link>
      <router-link to="/student-quality/class-menu" class="router-link">
        <el-menu-item
            index="4-7"
            v-if="checkPermission(['studentQuality_menu'])"
            @click="changeBreadcrumbMethod('student-quality-class-menu')"
        >Thực đơn
        </el-menu-item>
      </router-link>
    </el-submenu>
    <el-submenu index="5" class="menu-group-chart">
      <template #title>
        <i class="el-icon-s-data"/>
        <span>Thống kê</span>
      </template>
      <router-link to="/chart/statistical/attendance" class="router-link">
        <el-menu-item
            index="5-1"
            @click="changeBreadcrumbMethod('chart-statistical-attendance')"
        >Điểm danh
        </el-menu-item>
      </router-link>
      <router-link to="/chart/statistical/evaluate" class="router-link">
        <el-menu-item
            index="5-2"
            @click="changeBreadcrumbMethod('chart-statistical-evaluate')"
        >Nhận xét
        </el-menu-item>
      </router-link>
      <router-link to="/chart/statistical/album" class="router-link">
        <el-menu-item
            index="5-3"
            @click="changeBreadcrumbMethod('chart-statistical-album')"
        >Album ảnh
        </el-menu-item>
      </router-link>
    </el-submenu>
    <el-submenu index="6" class="menu-group-common"
                v-if=" checkPermission(['statisticalCommon'])">
      <template #title>
        <i class="el-icon-s-operation"/>
        <span>Thống kê chung</span>
      </template>
      <router-link to="/teacher/statistical" class="router-link">
        <el-menu-item
            index="6-1"
            v-if="checkPermission(['statisticalCommon_attendance'])"
            @click="changeBreadcrumbMethod('teacher-statistical')"
        >
          Thống kê điểm danh
        </el-menu-item>
      </router-link>
    </el-submenu>
    <el-submenu index="7" class="menu-group-birthday"
                v-if=" checkPermission(['birthday'])   ">
      <template #title>
        <i class="el-icon-burger"/>
        <span>Quản lý sinh nhật</span>
      </template>
      <router-link to="/birthday/kids" class="router-link">
        <el-menu-item
            index="7-1"
            v-if="checkPermission(['birthday_kids'])"
            @click="changeBreadcrumbMethod('birthday-kids')"
        >Sinh nhật học sinh
        </el-menu-item>
      </router-link>
      <router-link to="/birthday/parent" class="router-link">
        <el-menu-item
            index="7-2"
            v-if="checkPermission(['birthday_parent'])"
            @click="changeBreadcrumbMethod('birthday-parent')"
        >Sinh nhật phụ huynh
        </el-menu-item>
      </router-link>
    </el-submenu>
    <el-submenu index="8" class="menu-group-support">
      <template #title>
        <i class="el-icon-question"/>
        <span>Hỗ trợ &amp; hướng dẫn</span>
      </template>
      <a
          v-for="item in supportList"
          :key="item.name"
          class="router-link"
          :href="item.link"
          target="_blank"
          style="display: block"
      >
        <el-menu-item :index="item.name">{{ item.name }}</el-menu-item>
      </a>
    </el-submenu>
    </el-menu>
  </div>
</template>
<script>
import checkPermission from "@/utils/permission";
import {mapGetters, mapState} from "vuex";

export default {
  name: 'MenuTeacher',
  data() {
    return {
      breadcrumbDataList: [
        //bản tin
        {
          key: "appsend-notification",
          value: [{url: "/appsend/notification", name: "Thông báo hệ thống"}],
        },
        {
          key: "appsend-parent-feedback",
          value: [{url: "/appsend/parent-feedback", name: "Phụ huynh góp ý"}],
        },
        {
          key: "appsend-teacher-feedback",
          value: [{url: "/appsend/teacher-feedback", name: "Giáo viên góp ý"}],
        },
        //nhật ký phụ huynh
        {
          key: "parentdiary-message-parent",
          value: [{url: "/parentdiary/message-parent", name: "Lời nhắn"}],
        },
        {
          key: "parentdiary-medicine",
          value: [{url: "/parentdiary/medicine", name: "Dặn thuốc"}],
        },
        {
          key: "parentdiary-take-leave",
          value: [{url: "/parentdiary/take-leave", name: "Xin nghỉ"}],
        },
        {
          key: "absent-letter_v4",
          value: [{url: "/absent_letter/daily", name: "Xin nghỉ"}],
        },
        //quản lý nhân sự
        {
          key: "employee-department",
          value: [{url: "/employee/department", name: "Danh sách phòng ban"}],
        },
        {
          key: "employee-employees",
          value: [{url: "/employee/employees", name: "Danh sách nhân sự"}],
        },
        //danh sách học sinh
        {
          key: "student-students",
          value: [{url: "/student/students", name: "Danh sách học sinh"}],
        },
        //chất lượng học sinh
        {
          key: "student-quality-attendance",
          value: [{url: "/student-quality/attendance", name: "Điểm danh"}],
        },
        {
          key: "student-quality-attendance_v2",
          value: [{url: "/student-quality/attendance/v2", name: "Điểm danh"}],
        },
        {
          key: "attendance-v4",
          value: [{url: "/attendance/daily", name: "Điểm danh"}],
        },
        {
          key: "student-quality-evaluate",
          value: [{url: "/student-quality/evaluate", name: "Nhận xét"}],
        },
        {
          key: "student-evaluation-v4",
          value: [{url: "/evaluation-v4", name: "Nhận xét"}],
        },
        {
          key: "student-quality-album",
          value: [{url: "/album-v2", name: "Album ảnh"}],
        },
        {
          key: "student-quality-height-weight",
          value: [
            {
              url: "/student-quality/height-weight",
              name: "Chiều cao, cân nặng",
            },
          ],
        },
        {
          key: "student-quality-schedule",
          value: [{url: "/student-quality/schedule", name: "Thời khóa biểu"}],
        },
        {
          key: "student-quality-class-menu",
          value: [{url: "/student-quality/class-menu", name: "Thực đơn"}],
        },
        //quản lý sinh nhật
        {
          key: "birthday-kids",
          value: [{url: "/birthday/kids", name: "Sinh nhật học sinh"}],
        },
        {
          key: "birthday-parent",
          value: [{url: "/birthday/parent", name: "Sinh nhật phụ huynh"}],
        },
        //thống kê biểu đồ
        {
          key: "chart-statistical-attendance",
          value: [{url: "/chart/statistical/attendance", name: "Điểm danh"}],
        },
        {
          key: "chart-statistical-evaluate",
          value: [{url: "/chart/statistical/evaluate", name: "Nhận xét"}],
        },
        {
          key: "chart-statistical-album",
          value: [{url: "/chart/statistical/album", name: "Album ảnh"}],
        },
        {
          key: "notifihis-notify-teacher",
          value: [{url: "/notifihis/notify-teacher", name: "Tin tức lớp học"}],
        },
      ],
    }
  },
  created() {
    this.$store.dispatch('commonDataStore/fetchDataSupportList');
  },
  computed: {
    // getIsOpenCloseManu() {
    //   return this.$store.getters["layout/getIsOpenClose"];
    // },
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
    ...mapState("notificationNavbarStore", ["activeMenuIndex", "openSubMenu"]),
    ...mapGetters('commonDataStore',['supportList']),
  },
  methods: {
    checkPermission,
    handleMenuSelect(index, indexPath) {
      const sidebar = document.querySelector('.sidebar-wrapper');
      const savedScrollTop = sidebar ? sidebar.scrollTop : 0;

      // Lưu toàn bộ các submenu cha (bỏ phần tử cuối là menu-item được click)
      const openSubMenuList = (indexPath || []).slice(0, -1);
      this.$store.dispatch("notificationNavbarStore/handleActiveSubmenu", {
        menuIndex: openSubMenuList,
        menuItemIndex: index,
      });

      this.$nextTick(() => {
        if (sidebar) sidebar.scrollTop = savedScrollTop;
      });
    },
    changeBreadcrumbMethod(val) {
      let selectUrl = this.breadcrumbDataList.filter((x) => x.key === val);
      if (selectUrl.length === 1) {
        let dataList = selectUrl[0].value;
        sessionStorage.setItem("breadcrumbList", JSON.stringify(dataList));
        this.$store.dispatch("layout/setBreadcrumbActions", dataList);
      }
    },

  },

}

</script>
<style lang="scss" scoped>
.menu-main {
  min-height: 950px;
  padding: 10px 12px 16px;
  background:
      radial-gradient(circle at top left, rgba(157, 197, 255, 0.28), transparent 28%),
      radial-gradient(circle at 100% 12%, rgba(255, 196, 214, 0.22), transparent 24%),
      linear-gradient(180deg, #f9fbff 0%, #f3f7ff 52%, #eef4fb 100%);
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 700px;
  font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
  border-right: none !important;
  border-radius: 18px;
  overflow: hidden;
}

.router-link {
  text-decoration: none;
}

.el-menu-item.menu-logo-item {
  background: linear-gradient(135deg, #eef2ff 0%, #e3efff 52%, #f5e8ff 100%) !important;
  border-bottom: 1px solid #d7e3ff !important;
  height: 60px !important;
  line-height: normal !important;
  margin-bottom: 6px;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  &:hover {
    background: linear-gradient(135deg, #e8f0ff 0%, #dbebff 50%, #f0e4ff 100%) !important;
    border-left-color: transparent !important;
  }
}

.menu-logo-icon {
  color: #5b7fd8 !important;
  font-size: 20px !important;
  background: linear-gradient(135deg, rgba(91, 127, 216, 0.16), rgba(173, 114, 255, 0.14));
  width: 30px;
  height: 30px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

/deep/ .el-menu--collapse .menu-logo-icon {
  margin-right: 0 !important;
}

.onekids-title {
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 1.2px;
  color: #2f436d !important;
  text-transform: uppercase;
}

.el-menu-item {
  background-color: transparent !important;
  height: 40px !important;
  line-height: 40px !important;
  font-size: 14px !important;
  color: #6c7b98 !important;
  border-left: 3px solid transparent !important;
  padding-left: 46px !important;
  border-radius: 10px !important;
  margin: 2px 8px !important;
  transition: all 0.22s ease;

  &:hover {
    background: linear-gradient(90deg, var(--menu-item-hover-start, #f2f7ff) 0%, var(--menu-item-hover-end, #eaf1ff) 100%) !important;
    color: #324b78 !important;
    border-left-color: var(--menu-accent, #7aa8ff) !important;
  }

  &.is-active {
    background: linear-gradient(90deg, var(--menu-active-start, #dfeaff) 0%, var(--menu-active-end, #d4e2ff) 100%) !important;
    color: #29456f !important;
    border-left: 3px solid var(--menu-accent-strong, #5d83dd) !important;
    font-weight: 600;
    box-shadow: inset 0 0 0 1px var(--menu-accent-border, rgba(93, 131, 221, 0.12));
  }
}

/deep/ .el-submenu__title {
  height: 48px !important;
  line-height: 48px !important;
  font-size: 14px !important;
  font-weight: 600;
  color: #5f6f8f !important;
  border-left: 3px solid transparent;
  border-radius: 12px;
  margin: 4px 8px;
  transition: all 0.25s ease;

  i {
    color: var(--menu-accent, #7e91b2) !important;
    font-size: 15px;
    margin-right: 8px;
    transition: color 0.2s ease;
  }

  > i:first-child {
    width: 28px;
    height: 28px;
    border-radius: 10px;
    margin-right: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: var(--menu-accent-soft, rgba(93, 131, 221, 0.12));
    box-shadow: inset 0 0 0 1px var(--menu-accent-border, rgba(93, 131, 221, 0.14));
  }

  &:hover {
    background: linear-gradient(90deg, var(--menu-hover-start, #eff5ff) 0%, var(--menu-hover-end, #e8f0ff) 100%) !important;
    color: #324b78 !important;
    border-left-color: var(--menu-accent, #7aa8ff) !important;

    i {
      color: var(--menu-accent-strong, #5d83dd) !important;
    }
  }
}

/deep/ .el-submenu.is-opened > .el-submenu__title {
  background: linear-gradient(90deg, var(--menu-open-start, #edf4ff) 0%, var(--menu-open-end, #e5efff) 100%) !important;
  color: #2f436d !important;
  border-left: 3px solid var(--menu-accent, #6d96f5) !important;

  i {
    color: var(--menu-accent-strong, #5d83dd) !important;
  }
}

/deep/ .el-submenu__icon-arrow {
  color: #8b9aba !important;
  font-size: 11px;
  right: 12px;
}

/deep/ .el-message-box {
  display: inline-block;
  vertical-align: top !important;
  width: 420px;
  padding-bottom: 10px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  font-size: 18px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: left;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

/deep/ .el-message-box__wrapper::after {
  content: "";
  display: inline-block;
  height: 100%;
  width: 0;
  vertical-align: top !important;
}

.el-menu {
  margin-bottom: 20px;
  border: 1px solid #e2eaf7 !important;
  box-shadow: 0 10px 30px rgba(65, 84, 118, 0.08);
  background: rgba(255, 255, 255, 0.82) !important;
  backdrop-filter: blur(6px);
}

.menu-group-diary {
  --menu-accent: #5b9df6;
  --menu-accent-strong: #3f83df;
  --menu-accent-soft: rgba(91, 157, 246, 0.16);
  --menu-accent-border: rgba(91, 157, 246, 0.18);
  --menu-hover-start: #eef7ff;
  --menu-hover-end: #e5f1ff;
  --menu-open-start: #e7f4ff;
  --menu-open-end: #deeeff;
  --menu-item-hover-start: #eef7ff;
  --menu-item-hover-end: #e4f0ff;
  --menu-active-start: #dff0ff;
  --menu-active-end: #d4ebff;
}

.menu-group-student,
.menu-group-quality,
.menu-group-birthday {
  --menu-accent: #ff9f43;
  --menu-accent-strong: #f08a20;
  --menu-accent-soft: rgba(255, 159, 67, 0.16);
  --menu-accent-border: rgba(255, 159, 67, 0.2);
  --menu-hover-start: #fff7ee;
  --menu-hover-end: #ffefdf;
  --menu-open-start: #fff2e4;
  --menu-open-end: #ffe8d0;
  --menu-item-hover-start: #fff7ee;
  --menu-item-hover-end: #ffefdf;
  --menu-active-start: #ffeccf;
  --menu-active-end: #ffe2bb;
}

.menu-group-chart {
  --menu-accent: #8b7cf6;
  --menu-accent-strong: #7161e8;
  --menu-accent-soft: rgba(139, 124, 246, 0.15);
  --menu-accent-border: rgba(139, 124, 246, 0.18);
  --menu-hover-start: #f4f2ff;
  --menu-hover-end: #ebe8ff;
  --menu-open-start: #efebff;
  --menu-open-end: #e6e0ff;
  --menu-item-hover-start: #f4f2ff;
  --menu-item-hover-end: #ece8ff;
  --menu-active-start: #e5deff;
  --menu-active-end: #dbd2ff;
}

.menu-group-common,
.menu-group-support {
  --menu-accent: #4bb6c9;
  --menu-accent-strong: #2a9dad;
  --menu-accent-soft: rgba(75, 182, 201, 0.16);
  --menu-accent-border: rgba(75, 182, 201, 0.18);
  --menu-hover-start: #eefbfd;
  --menu-hover-end: #e3f7fa;
  --menu-open-start: #e6f7fb;
  --menu-open-end: #d9f2f7;
  --menu-item-hover-start: #eefbfd;
  --menu-item-hover-end: #e2f6fa;
  --menu-active-start: #d8f0f5;
  --menu-active-end: #caebf2;
}

@media (max-width: 1200px) {
  .menu-main {
    padding: 8px;
  }
}
</style>



